
import React, { useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import * as api from "../../api/index";
import { FiEdit, FiPlus, FiLogOut, FiCreditCard, FiHome,FiDollarSign , FiPlusSquare, FiMail, FiUser, FiZap, FiPackage, FiMapPin, FiAward, FiHeadphones, FiMessageSquare } from "react-icons/fi";

const Dashboard = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("token") || "";
  
  let decoded = { id: "", level: 0, name: "User", typeofuser: "Customer" };
  try {
    decoded = jwtDecode(token);
  } catch (err) {
    // navigate("/auth") logic could go here if needed
  }

  const userId = decoded.id || decoded._id;
  const userLevel = decoded.level;
  const name = decoded.name;
  const typeofuser = decoded.typeofuser;
  const riderverified = decoded.riderverified || false;

  const [conversationLoading, setConversationLoading] = useState(false);
  const phoneNumber = "2349026235719"; 
  const message = encodeURIComponent("Hello,");

  const handleWhatsAppClick = () => {
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
  };

  const handleStartConversation = async () => {
    if (!userId) return navigate("/auth");
    setConversationLoading(true);

    const dataObject = {
      Name: "Ourasap Service",
      Email: "support@ourasap.com",
      profileImage: "https://ik.imagekit.io/1h5qhnqzz/profiles/F653402A-487E-4336-9FBE-625BE665F4C6_Ge1YoRGCt.jpeg",
      _id: "68d1549e1c0789563e71cd6b"
    };

    try {
      const res = await api.createConversation({
        senderId: userId,
        receiverId: "68d1549e1c0789563e71cd6b",
      });
      if (res?.data?.conversation._id) {
        navigate(`/chat/${res.data.conversation._id}`, {
          state: { otherUser: dataObject },
        });
      }
    } catch (err) {
      alert("Something went wrong. Please try again.");
    } finally {
      setConversationLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F8F9FA] pb-24">
      {/* 🚀 Dynamic Header */}
      <header className="bg-gray-900 text-white pt-12 pb-20 px-6 rounded-b-[3rem] shadow-2xl relative overflow-hidden">
        <div className="absolute top-0 right-0 w-64 h-64 bg-orange-600/20 rounded-full blur-3xl -mr-20 -mt-20"></div>
        
        <div className="max-w-6xl mx-auto relative z-10">
          <div className="flex justify-between items-start">
            <div>
              <p className="text-orange-500 text-[10px] font-black uppercase tracking-[0.3em] mb-2">Authenticated Session</p>
              <h1 className="text-3xl font-black tracking-tighter">Welcome, {name}</h1>
              <p className="text-gray-400 text-xs font-bold mt-1 uppercase tracking-wider">Find Quality Sellers & Products Near You</p>
            </div>
            
            {/* ⭐ Level Badge */}
            <div className="bg-white/10 backdrop-blur-md border border-white/20 px-4 py-2 rounded-2xl flex items-center gap-2">
              <FiZap className="text-orange-500" />
              <span className="text-[10px] font-black uppercase tracking-widest text-white">
                {userLevel === 0 && (typeofuser === "Customer" ? "New Buyer" : typeofuser === "Seller" ? "New Seller" : "New Rider")}
                {userLevel === 1 && (typeofuser === "Customer" ? "Beginner" : typeofuser === "Seller" ? "Starter Seller" : "Rider Onboarding")}
                {userLevel === 2 && (typeofuser === "Customer" ? "Regular" : typeofuser === "Seller" ? "Growing Seller" : "Trusted Rider")}
                {userLevel === 3 && (typeofuser === "Customer" ? "Pro Buyer" : typeofuser === "Seller" ? "Pro Seller" : "Verified Rider")}
                {userLevel === 4 && (typeofuser === "Customer" ? "VIP" : typeofuser === "Seller" ? "Elite Seller" : "Top Rider")}
              </span>
            </div>
          </div>
        </div>
      </header>

      {/* 🛠 Admin & Notifications */}
      <div className="max-w-6xl mx-auto px-6 -mt-8 relative z-20">
        {decoded.email === "support@ourasap.com" && (
          <button
            onClick={() => navigate("/admindashboard")}
            className="w-full mb-4 bg-red-600 text-white py-4 rounded-2xl font-black text-xs uppercase tracking-widest shadow-xl shadow-red-200"
          >
            Access Admin Control Panel
          </button>
        )}

        {/* 🎯 Action Center */}
        <div className="bg-white p-6 rounded-[2.5rem] shadow-xl shadow-gray-200/50 border border-gray-100 mb-8">
          <h2 className="text-center font-black text-gray-900 uppercase tracking-tighter text-sm mb-6">Buy, Sell and Deliver Anything</h2>
          
          <div className="grid grid-cols-2 gap-4">
            <button
              onClick={() => navigate("/select")}
              className="bg-orange-600 hover:bg-orange-700 text-white font-black text-[11px] uppercase tracking-widest py-4 rounded-2xl transition-all shadow-lg shadow-orange-100 active:scale-95"
            >
              Find Sellers
            </button>
            <button
              onClick={() => navigate("/select-product")}
              className="bg-gray-900 hover:bg-black text-white font-black text-[11px] uppercase tracking-widest py-4 rounded-2xl transition-all shadow-lg shadow-gray-200 active:scale-95"
            >
              Find Products
            </button>
          </div>

          <button
            onClick={handleWhatsAppClick}
            className="w-full mt-4 bg-teal-600 hover:bg-teal-700 text-white font-black text-[11px] uppercase tracking-widest py-4 rounded-2xl transition-all shadow-lg shadow-teal-100 flex items-center justify-center gap-2"
          >
            <FiMessageSquare size={18} />
            Chat on WhatsApp
          </button>
        </div>

        {/* 🛡️ Rider Verification Banner */}
        {typeofuser === "Rider" && (
          <div className={`p-6 rounded-[2rem] border-2 mb-8 ${riderverified ? 'bg-green-50 border-green-100' : 'bg-red-50 border-red-100'}`}>
            <p className={`text-xs font-bold leading-relaxed text-center ${riderverified ? 'text-green-800' : 'text-red-700'}`}>
              {riderverified 
                ? "You will receive messages when orders match your LGA." 
                : "Credential Verification Pending: We will schedule a video call within 24 hours to verify your address."}
            </p>
          </div>
        )}

        {/* 🍱 Bento Grid Sections */}
        <div className="grid grid-cols-2 gap-4 ">
          {/* Orders */}
          <div
            onClick={() => navigate("/orders")}
            className="bg-white p-6 rounded-[2rem] shadow-sm border border-gray-100 hover:shadow-xl hover:shadow-gray-200/50 transition-all cursor-pointer group"
          >
            <div className="w-12 h-12 bg-blue-50 text-blue-600 rounded-2xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
              {typeofuser === "Rider" ? <FiZap size={24} /> : <FiPackage size={24} />}
            </div>
            <h3 className="font-black text-gray-900 uppercase tracking-tight text-sm mb-1">
              {typeofuser === "Rider" ? "Deliveries" : "My Orders"}
            </h3>
            <p className="text-[10px] font-bold text-gray-400 leading-normal uppercase">Track pending & completed activity</p>
          </div>

          {/* Track Delivery */}
          <div
            onClick={() => navigate("/track-order")}
            className="bg-white p-6 rounded-[2rem] shadow-sm border border-gray-100 hover:shadow-xl hover:shadow-gray-200/50 transition-all cursor-pointer group"
          >
            <div className="w-12 h-12 bg-purple-50 text-purple-600 rounded-2xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
              <FiMapPin size={24} />
            </div>
            <h3 className="font-black text-gray-900 uppercase tracking-tight text-sm mb-1">Live Track</h3>
            <p className="text-[10px] font-bold text-gray-400 leading-normal uppercase">Real-time GPS delivery tracking</p>
          </div>

          {/* Levels */}
          <div
            onClick={() => navigate(typeofuser === "Customer" ? "/level" : typeofuser === "Seller" ? "/level-seller" : "/level-riders")}
            className="bg-white p-6 rounded-[2rem] shadow-sm border border-gray-100 hover:shadow-xl hover:shadow-gray-200/50 transition-all cursor-pointer group"
          >
            <div className="w-12 h-12 bg-yellow-50 text-yellow-600 rounded-2xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
              <FiAward size={24} />
            </div>
            <h3 className="font-black text-gray-900 uppercase tracking-tight text-sm mb-1">Status</h3>
            <p className="text-[10px] font-bold text-gray-400 leading-normal uppercase">Unlock higher perks & rewards</p>
          </div>

          {/* Support */}
          <div
             onClick={() => navigate("/contactUs")}
            className="bg-white p-6 rounded-[2rem] shadow-sm border border-gray-100 hover:shadow-xl hover:shadow-gray-200/50 transition-all cursor-pointer group"
          >
            <div className="w-12 h-12 bg-teal-50 text-teal-600 rounded-2xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
              {conversationLoading ? <div className="w-5 h-5 border-2 border-teal-600 border-t-transparent rounded-full animate-spin"></div> : <FiHeadphones size={24} />}
            </div>
            <h3 className="font-black text-gray-900 uppercase tracking-tight text-sm mb-1">Support</h3>
            <p className="text-[10px] font-bold text-gray-400 leading-normal uppercase">Instant assistance 24/7</p>
          </div>
        </div>

        {/* 🏢 About Section */}
        <footer className="mt-16 mb-8 text-center px-6">
          <div className="h-px bg-gray-200 w-24 mx-auto mb-8"></div>
          <h4 className="text-[11px] font-black text-gray-900 uppercase tracking-[0.3em] mb-3">About OurASAP</h4>
          <p className="text-[10px] font-bold text-gray-400 leading-loose uppercase max-w-sm mx-auto">
            Connecting buyers, sellers, and riders for seamless hyperlocal commerce. Secure deliveries, every time.
          </p>
        </footer>
      </div>

      {/* 🧭 Bottom Navigation Bar */}
      <nav className="fixed bottom-0 left-0  hidden  right-0 bg-white/80 backdrop-blur-xl border-t border-gray-100 md:flex justify-around items-center py-4 z-50 shadow-[0_-10px_30px_rgba(0,0,0,0.03)]">
        <button onClick={() => navigate("/")} className="flex flex-col items-center gap-1 text-orange-600 transition-all">
          <FiHome size={22} />
          <span className="text-[9px] font-black uppercase tracking-widest">Home</span>
        </button>

        <button onClick={() => navigate("/sellproduct")} className="flex flex-col items-center gap-1 text-gray-400 hover:text-orange-600 transition-all">
          <FiPlusSquare size={22} />
          <span className="text-[9px] font-black uppercase tracking-widest">Post</span>
        </button>

           <button onClick={() => navigate(`/balancepage/${userId}`)} className="flex flex-col items-center gap-1 text-gray-400 hover:text-orange-600 transition-all">
          <FiCreditCard size={22} />
          <span className="text-[9px] font-black uppercase tracking-widest">Wallet</span>
        </button>

        <button onClick={() => navigate("/conversations")} className="flex flex-col items-center gap-1 text-gray-400 hover:text-orange-600 transition-all">
          <FiMail size={22} />
          <span className="text-[9px] font-black uppercase tracking-widest">Inbox</span>
        </button>

        <button 
          onClick={() => typeofuser === "Customer" ? navigate("/profile") : navigate("/profile-seller")} 
          className="flex flex-col items-center gap-1 text-gray-400 hover:text-orange-600 transition-all"
        >
          <FiUser size={22} />
          <span className="text-[9px] font-black uppercase tracking-widest">Profile</span>
        </button>
      </nav>
    </div>
  );
};

export default Dashboard;